export default {
  validate(value, args) {
    return value >= 1 && value <= 100;
  },
};
